import { render } from "./DealBuyRule.vue?vue&type=template&id=555339e2&scoped=true"
const script = {}

import "./DealBuyRule.vue?vue&type=style&index=0&id=555339e2&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555339e2"]])

export default __exports__